import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import Project from "./Project";
import projects from "./projects";
import "./Work.css";

function Work() {
  // Script burger menu
  useEffect(() => {
    const burger = document.getElementById("burger");
    const navLinks = document.getElementById("nav-links");

    const toggleMenu = () => {
      navLinks.classList.toggle("active");
      burger.classList.toggle("toggle");
    };

    burger.addEventListener("click", toggleMenu);
    return () => burger.removeEventListener("click", toggleMenu);
  }, []);

  return (
    <>
      <Header />
      <article>
        <h1>MES TRAVAUX</h1>

        <div className="projects-grid">
          {projects.map((project) => (
            <Project
              key={project.title}
              img={project.img}
              title={project.title}
              techno={project.techno}
              description={project.description}
              technos={project.technos}
              competences={project.competences}
              github={project.github}
              site={project.site}
            />
          ))}
        </div>
      </article>
      <Footer />
    </>
  );
}

export default Work;
